@if (singleBookmarkSelected()) {
  <div class="detail-form">
    <h3>Bookmark Details</h3>
    <form [formGroup]="editForm" (ngSubmit)="saveChanges()">
      <div class="field">
        <label>Title</label>
        <input type="text" formControlName="title" name="title" />
      </div>
      <div class="field">
        <label>URL</label>
        <input type="text" formControlName="url" name="url" />
      </div>
      <div class="tags-section">
        <label>Tags</label>
        <div class="tags-list">
          <div *ngFor="let tag of currentTags()" class="tag-chip">
            {{ tag }}
            <button type="button" (click)="removeTag(tag)">×</button>
          </div>
        </div>
        <div class="tag-input">
          <input #newTag type="text" placeholder="Add tag..." (keyup.enter)="addTag(newTag)">
        </div>
      </div>

      <div class="actions">
        <button type="submit" class="save-btn" [disabled]="isSaving() || editForm.pristine">
          {{ isSaving() ? 'Saving...' : 'Save' }}
        </button>
        <button type="button" class="ai-btn" (click)="aiCategorize()" [disabled]="isCategorizing()">
          {{ isCategorizing() ? 'Categorizing...' : 'AI Categorize' }}
        </button>
      </div>
    </form>
  </div>
}
 @else if (singleFolderSelected()) {
  <div class="detail-info">
    <h3>Folder Details</h3>
    <strong>Name: {{ selection()![0].title }}</strong>
    <p>Type: Folder</p>
  </div>
} @else if (onlyBookmarksSelected()) {
  <div class="selection-info">
  <div class="header">
    <strong>Selected {{selection()?.length}} bookmarks</strong>
  </div>

  <div class="tags-section">
    <label>Common Tags (assigned to all selected)</label>
    <div class="tags-list">
      <div *ngFor="let tag of currentTags()" class="tag-chip">
        {{ tag }}
        <button (click)="removeTag(tag)" title="Remove tag from all selected">×</button>
      </div>
      <div *ngIf="currentTags().length === 0" class="no-tags">
        No common tags
      </div>
    </div>
    <div class="tag-input">
      <input #newBatchTag type="text" placeholder="Add tag to all selected..." (keyup.enter)="addTag(newBatchTag)">
    </div>
  </div>

    <div class="actions">
      <button class="ai-btn" (click)="aiCategorize()" [disabled]="isCategorizing()">
      {{ isCategorizing() ? 'AI Categorizing...' : 'AI Categorize All' }}
      </button>
    </div>
  </div>
} @else if (mixedSelection()) {
  <div class="selection-info">
    <p>Selected {{selection()?.length}} items (mixed folders and bookmarks)</p>
  </div>
} @else {
  <div class="no-selection">
    <p>No item selected or selection empty</p>
    <p>Selection size: {{ selection()?.length }}</p>
    <p>Single Item Selected: {{ singleItemSelected() }}</p>
  </div>
}
